class ErrorDescriptionService {

	constructor() {

		this.errors = [
			{dialog: true, errorType: "ErrorException", errorCode: 0, errorDescription: "Unspecified error!"},
			{dialog: true, errorType: "User", errorCode: 3, errorDescription: "Sorry! We're currently experiencing a few problems on our end. Please try signing in later."},
			{dialog: true, errorType: "Cinema", errorCode: 5, errorDescription: "Looks like this cinema is currently unavailble! Please use your location to find the nearest cinema to you or try again later."},
			{dialog: true, errorType: "Payment", errorCode: 12, errorDescription: "Payment Status: We’re sorry, but this payment could not be processed. Please contact your financial institution and try again or try a different card."},
			{dialog: true, errorType: "VistaApiException", errorCode: 1002, errorDescription: "Looks like this email is already in use. <a href='/user/login'>Sign in</a> or <a href='/user/password-reset/email'>reset your password</a>."},
			{dialog: true, errorType: "VistaApiException", errorCode: 1003, errorDescription: "Sorry! Looks like your membership details couldn't be found. Please double check you've entered the correct card number or call Customer Care on 0861 668 437 for further assistance."},
			{dialog: true, errorType: "VistaApiException", errorCode: 1004, errorDescription: "Sorry! Looks like this movie can't be booked right now"},
			{dialog: true, errorType: "FatalErrorException", errorCode: 1005, errorDescription: "Hmm, looks like the card number you've entered is invalid. Please double check you’ve entered the right number."},
			{dialog: true, errorType: "VistaAuthenticationException", errorCode: 17, errorDescription: "Hmm, we can't seem to recognise you. Please double check your email and password are correct. If you've forgotten your password, <a href='/user/password-reset/email'>reset it now</a> and if you've forgotten your email address contact Customer Care on 0861 668 437 for further assistance."},
			{dialog: true, errorType: "Payment", errorCode: 28, errorDescription: "Payment status: We're sorry, but this payment could not be processed. Please contact your financial institution and try again or use a different card."},
			{dialog: true, errorType: "Payment", errorCode: 47, errorDescription: "Your booking session is about to expire! Please click continue to carry on."},
			{dialog: true, errorType: "Payment", errorCode: 49, errorDescription: "Looks like your booking session has expired. Don't worry, it's easy to start again."},
			{dialog: true, errorType: "Payment", errorCode: 554, errorDescription: "The Payment gateway could not be contacted, please try again."},
			{dialog: true, errorType: "Voucher", errorCode: 60, errorDescription: "Sorry! This voucher has already been used."},
			{dialog: false, errorType: "VistaAPIError", errorCode: 43, errorDescription: "This email already exists"},
			{dialog: true, errorType: "VistaValidateError", errorCode: 5541, errorDescription: "Could not validate, please try again later."},
		];

		this.errorsByStringContains = [
			{ stringContains:"This member already exists in this club as member", error: this.errors[4]},
			{ stringContains:"Email address already in use", error: this.errors[4]},
			{ stringContains:"DB Exception", error: this.errors[15]},

		];
	}



	getErrorFromCode(errorCode, errorType,error) {

		if(error.error && Array.isArray(error.error) && error.error.length > 0) {
			// if(error.error[0] == "Unable to Update Order") {
			// 	return false;
			// }
			// console.log("matching error from string!",error.error[0])
			for (var i = 0; i < this.errorsByStringContains.length; i++) {
				let errorTest = this.errorsByStringContains[i];
				if (~error.error[0].indexOf(errorTest.stringContains)) {
					// console.log(errorTest.error)
					return errorTest.error;
				}
			}			
		}
 
        for(var i = 0; i < this.errors.length; i++) {
        	if((this.errors[i].errorCode == errorCode) && (this.errors[i].errorType == errorType)) {
        		return this.errors[i];
        	}
        }
    }
}

export default new ErrorDescriptionService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/error-description-service.js